const gregFmt = new Intl.DateTimeFormat('ar-EG', { day: '2-digit', month: '2-digit', year: 'numeric' });
const hijriFmt = new Intl.DateTimeFormat('ar-SA', { day: '2-digit', month: '2-digit', year: 'numeric' });
const timeFmt = new Intl.DateTimeFormat('ar-EG', { hour: '2-digit', minute: '2-digit' });

function toDate(d) {
  if (!d) return null;
  const date = d instanceof Date ? d : new Date(d);
  return isNaN(date) ? null : date;
}

export function fmtDateBoth(d) {
  const date = toDate(d);
  if (!date) return '—';
  return `${gregFmt.format(date)} · ${hijriFmt.format(date)} هـ`;
}

export function fmtDateTimeBoth(d) {
  const date = toDate(d);
  if (!date) return '—';
  return `${gregFmt.format(date)} ${timeFmt.format(date)} · ${hijriFmt.format(date)} هـ`;
}

export function fmtDate(d) {
  const date = toDate(d);
  return date ? gregFmt.format(date) : '—';
}
